import { render } from "./Processing-page.vue?vue&type=template&id=78009121"
import script from "./Processing-page.vue?vue&type=script&lang=js"
export * from "./Processing-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__